import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/declaracaoCartorio/';

class DeclaracaoCartorio {
  constructor() {
    LoginService.currentUser.subscribe((data) => {
      this.headers = {
        'Content-Type': 'application/json',
        authorization: 'Bearer ' + (data ? data.token : ''),
      };
    });
  }

  findAllDeclaracoes(idContribuinte, ano, mes) {
    return axios.get(API_URL + 'allDeclaracoes?idContribuinte=' + idContribuinte + '&ano=' + ano + '&mes=' + mes, {
      headers: this.headers,
    });
  }

  findAllDeclaracoesPorPeriodo(idContribuinte, dataIni, dataFim) {
    return axios.get(
      API_URL +
      'allDeclaracoesPorPeriodo?idContribuinte=' +
      idContribuinte +
      '&dataIni=' +
      dataIni +
      '&dataFim=' +
      dataFim,
      { headers: this.headers },
    );
  }

  salvar(dados) {
    return axios.post(API_URL + 'salvar', JSON.stringify(dados), { headers: this.headers });
  }

  encerrar(idCliente, idUsuario, idContribuinte, idDeclaracao) {
    return axios.post(
      API_URL +
      'encerrarDeclaracao?idCliente=' +
      idCliente +
      '&idContribuinte=' +
      idContribuinte +
      '&idUsuario=' +
      idUsuario +
      '&idDeclaracao=' +
      idDeclaracao,
      null,
      { headers: this.headers },
    );
  }

  editarAliquota(idContribuinte) {
    return axios.get(API_URL + 'editaAliquota?idContribuinte=' + idContribuinte, { headers: this.headers });
  }

  cancelar(idUsuario, idContribuinte, idDeclaracao) {
    return axios.post(
      API_URL +
      'cancelar?idContribuinte=' +
      idContribuinte +
      '&idUsuario=' +
      idUsuario +
      '&idDeclaracao=' +
      idDeclaracao,
      null,
      { headers: this.headers },
    );
  }

  findBoletos(id) {
    return axios.get(API_URL + 'allBoletos?idDeclaracao=' + id, { headers: this.headers });
  }

  atualizarVencimento(idDeclaracao, dataVencimento) {
    return axios.post(
      API_URL + 'atualizarVencimento?idDeclaracao=' + idDeclaracao + '&dataVencimento=' + dataVencimento,
      null,
      { headers: this.headers },
    );
  }

  criarPagamentoPix(idDecLancamento, idDeclaracao) {
    return axios.post(
      API_URL + 'criarPagamentoPix?idDecLancamento=' + idDecLancamento + '&idDeclaracao=' + idDeclaracao,
      null,
      { headers: this.headers },
    );
  }

  criarPagamentoPixCp(idCalculoParcelado, idDeclaracao) {
    return axios.post(
      API_URL + 'criarPagamentoPixCp?idCalculoParcelado=' + idCalculoParcelado + '&idDeclaracao=' + idDeclaracao,
      null,
      { headers: this.headers },
    );
  }

  consultarPagamentoPix(idDeclaracao, idDecLancamento) {
    return axios.get(
      API_URL + 'consultarPagamentoPix?idDeclaracao=' + idDeclaracao + '&idDecLancamento=' + idDecLancamento,
      { headers: this.headers },
    );
  }

  carregarAnexosDeclaracao(idDeclaracao) {
    return axios.get(API_URL + 'allAnexosDeclaracao?idDeclaracao=' + idDeclaracao, { headers: this.headers });
  }

  downloadAnexo(id, type, nome) {
    return axios({
      url: API_URL + 'exportDeclaracaoAnexo?idAnexo=' + id,
      method: 'POST',
      responseType: 'blob',
      data: null,
      headers: this.headers,
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data], { type: type }));
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      console.log(response);
      fileLink.setAttribute('download', nome);
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  }
}

export default new DeclaracaoCartorio();
